import React from 'react';
import { Proposal } from '../../hooks/useProposals'; // Changed from Project
import { ActionMenu } from '../shared';
import type { ActionMenuItem } from '../shared';
import { PencilIcon, TrashIcon, ArrowDownTrayIcon } from '@heroicons/react/24/outline';

interface ProposalActionsMenuProps { // Renamed interface
    proposal: Proposal; // Changed from project: Project
    handleEdit: (proposal: Proposal) => void; // Changed from project: Project
    handleDelete: (proposalId: string) => void; // Changed from projectId: string
}

// Renamed component
export default function ProposalActionsMenu({
    proposal, // Changed
    handleEdit,
    handleDelete,
}: ProposalActionsMenuProps) {
    const menuItems: ActionMenuItem[] = [
        {
            label: 'Editar',
            onClick: () => handleEdit(proposal), // Changed
            icon: PencilIcon,
            itemClassName: 'text-gray-700',
            iconClassName: 'text-gray-400',
        },
    ];

    // Add Download Proposal item if proposalUrl exists
    if (proposal.proposalUrl) { // Changed
        menuItems.push({
            label: 'Baixar Proposta',
            onClick: () => {
                // Open the proposalUrl in a new tab to trigger download or view
                window.open(proposal.proposalUrl, '_blank'); // Changed
            },
            icon: ArrowDownTrayIcon,
            itemClassName: 'text-gray-700',
            iconClassName: 'text-gray-400',
        });
    }

    // Add Delete item (always present, but might be disabled)
    menuItems.push({
        label: 'Excluir',
        onClick: () => { if (proposal.id) handleDelete(proposal.id); }, // Changed
        icon: TrashIcon,
        itemClassName: 'text-red-600',
        iconClassName: 'text-red-400',
        disabled: !proposal.id, // Changed
    });

    return <ActionMenu items={menuItems} />;
} 